if (!window.luneraCollectionPanelReady) {
  window.luneraCollectionPanelReady = true;
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (select.matches('[data-lunera-sort]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.href);
    } else if (select.matches('[data-lunera-target]') && select.value) {
      const url = new URL(select.value, window.location.origin);
      const current = new URL(window.location.href);
      const names = new Set([...current.searchParams.keys()].filter(key => key === 'sort_by' || key === 'preview_theme_id' || key.startsWith('filter.')));
      for (const key of names) {
        if (!url.searchParams.has(key)) {
          for (const value of current.searchParams.getAll(key)) url.searchParams.append(key, value);
        }
      }
      window.location.assign(url.href);
    }
  });
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('[data-lunera-browse-link], [data-lunera-clear-brand]') : null;
    if (!link) return;
    const url = new URL(link.href);
    if (url.origin !== window.location.origin) return;
    const current = new URL(window.location.href);
    for (const [key, value] of current.searchParams) {
      if (key === 'sort_by' || key === 'preview_theme_id') url.searchParams.set(key, value);
      else if (key.startsWith('filter.') && !link.matches('.lunera-collection-panel__clear, [data-lunera-clear-brand]')) {
        if (!url.searchParams.getAll(key).includes(value)) url.searchParams.append(key, value);
      }
    }
    url.searchParams.delete('page');
    link.href = url.href;
  }, true);
}

